/* ── Echo Valley — living hero ──
   Draws the plug-in's TEXTURE panel live on a canvas. This is a port of the
   plug-in's own drawing code, not a screenshot, so it stays sharp at any size
   and cannot show anything the product does not do.

   CPU discipline (this runs on a marketing page, not a DAW):
     - capped at ~30fps: the motion is ambient, 60 buys nothing
     - IntersectionObserver stops the loop the moment the hero leaves view
     - document.hidden stops it when the tab is in the background
     - prefers-reduced-motion draws exactly one frame and never loops
   ------------------------------------------------------------------------ */
(function () {
  var cv = document.getElementById('ev-panel');
  if (!cv || !cv.getContext) return;
  var g = cv.getContext('2d');
  var cv2 = document.getElementById('ev-panel-refl');
  var g2 = cv2 && cv2.getContext ? cv2.getContext('2d') : null;

  var INK = '#FFB9E2', INK2 = '#F072D2', DIM = '#8E4480', HOT = '#FFEEFA', BG = '#0D0410';
  var STAGE = ['#FF5FA0', '#EB5FD7', '#D45FFF', '#B470FF', '#9B7FFF'];
  var S = 2; // 620 design space -> 1240 backing store

  function rgba(h, a) {
    var n = parseInt(h.slice(1), 16);
    return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' +
      Math.max(0, Math.min(1, a)) + ')';
  }
  function hash(n) { var x = Math.sin(n) * 43758.5453; return x - Math.floor(x); }
  function mono(px, b) { return (b ? '700 ' : '400 ') + (px * S) + 'px ui-monospace,SFMono-Regular,Menlo,monospace'; }
  function tx(c, s, x, y, col, a, px, just, bold, glow) {
    c.save();
    if (glow) { c.shadowColor = rgba(col, .8); c.shadowBlur = glow * S; }
    c.font = mono(px, bold); c.textAlign = just || 'left'; c.fillStyle = rgba(col, a);
    c.fillText(s, x * S, y * S); c.restore();
  }
  function line(c, x0, y0, x1, y1, col, a, w) {
    c.strokeStyle = rgba(col, a); c.lineWidth = (w || 1) * S;
    c.beginPath(); c.moveTo(x0 * S, y0 * S); c.lineTo(x1 * S, y1 * S); c.stroke();
  }
  function box(c, x, y, w, h, col, a, lw) {
    c.strokeStyle = rgba(col, a); c.lineWidth = (lw || 1) * S; c.strokeRect(x * S, y * S, w * S, h * S);
  }
  function bar(c, x, y, w, h, v, col, t) {
    box(c, x, y, w, h, col, .45);
    var n = Math.floor((w - 4) / 6), f = Math.round(n * v), k, sh;
    for (k = 0; k < f; k++) {
      sh = .80 + .20 * Math.sin(k * .42 - t * 1.9);
      c.fillStyle = rgba(col, .9 * sh);
      c.fillRect((x + 3 + k * 6) * S, (y + 3) * S, 5 * S, (h - 6) * S);
    }
  }

  /* the four CHARACTER graphics */
  function glyph(c, kind, x, y, w, h, v, t, col) {
    c.save(); c.beginPath(); c.rect(x * S, y * S, w * S, h * S); c.clip();
    var cy = y + h / 2, i, u, k;
    if (kind === 0) {                       // SWELL - dense waveform, quiet slope in
      var ramp = .06 + .86 * v, N = Math.floor(w / 1.4);
      for (i = 0; i < N; i++) {
        u = i / N;
        var env = Math.pow(Math.min(1, u / ramp), 1.6);
        var n1 = hash(i * 3.1 + Math.floor(t * 14)), n2 = hash(i * 7.7);
        var n3 = .5 + .5 * Math.sin(u * 47 + t * 9);
        var pk = Math.max(.4, env * (.25 + .75 * Math.pow(n2, .6)) * (.55 + .45 * n3) * h * .46);
        var rms = pk * (.35 + .30 * n1);
        c.fillStyle = rgba(col, .30); c.fillRect((x + u * w) * S, (cy - pk) * S, 1 * S, pk * 2 * S);
        c.fillStyle = rgba(col, .95); c.fillRect((x + u * w) * S, (cy - rms) * S, 1 * S, rms * 2 * S);
      }
    } else if (kind === 1) {                // CRUNCH - clipping, hot, crackling
      var drive = 1 + v * 9;
      var sig = function (u) { return Math.tanh(Math.sin(u * 6.283 * 2.2 + t * 2.2) * drive) / Math.tanh(drive); };
      c.beginPath(); c.moveTo(x * S, cy * S);
      for (i = 0; i <= 48; i++) { u = i / 48; c.lineTo((x + u * w) * S, (cy - sig(u) * h * .42) * S); }
      c.lineTo((x + w) * S, cy * S); c.closePath();
      c.fillStyle = rgba(col, .10 + .30 * v); c.fill();
      c.save(); c.shadowColor = rgba(col, .9); c.shadowBlur = (5 + 11 * v) * S;
      c.strokeStyle = rgba(col, .98); c.lineWidth = 1.6 * S; c.beginPath();
      for (i = 0; i <= 48; i++) {
        u = i / 48; var yy = (cy - sig(u) * h * .42) * S;
        i ? c.lineTo((x + u * w) * S, yy) : c.moveTo((x + u * w) * S, yy);
      }
      c.stroke(); c.restore();
      var nsp = Math.floor(Math.pow(v, 1.4) * 22);
      for (k = 0; k < nsp; k++) {
        u = hash(k * 7.7 + Math.floor(t * 7)); var s = sig(u);
        if (Math.abs(s) < .9) continue;
        var sy = cy - s * h * .42 + (s > 0 ? -1 : 1) * (1 + hash(k * 3.3 + t) * 6 * v);
        c.fillStyle = k % 3 ? rgba(col, .5 + .5 * hash(k + t)) : rgba(HOT, .6 + .4 * hash(k));
        c.fillRect((x + u * w + (hash(k * 13) - .5) * 5) * S, sy * S, 1.4 * S, 1.4 * S);
      }
    } else if (kind === 2) {                // DARKNESS - terrain losing its detail
      /* deliberately the slowest graphic on the panel: its clock used to scale
         with (1-v), which made it fastest exactly when it was brightest. */
      var td = t * (.18 + .42 * (1 - v)), D = 1 - .62 * Math.pow(v, 1.6), open = 1 - v, B = y + h;
      var dsig = function (u) {
        var s = Math.sin(u * 6.283 * 1.1 + td * 1.6) * .5;
        s += Math.sin(u * 6.283 * 3.3 + td * 2.9) * .28 * open;
        s += Math.sin(u * 6.283 * 7.1 + td * 4.2) * .17 * open * open;
        s += (hash(Math.floor(u * 54) * 7.7 + Math.floor(td * 3)) - .5) * .55 * open * open * open;
        return s;
      };
      var wy = function (u) { return y + h * .34 - dsig(u) * h * .30; };
      var grd = c.createLinearGradient(0, y * S, 0, B * S);
      grd.addColorStop(0, rgba(col, .34 * D + .08)); grd.addColorStop(1, rgba(col, .05));
      c.fillStyle = grd; c.beginPath(); c.moveTo(x * S, B * S);
      for (i = 0; i <= 72; i++) { u = i / 72; c.lineTo((x + u * w) * S, wy(u) * S); }
      c.lineTo((x + w) * S, B * S); c.closePath(); c.fill();
      c.save(); c.shadowColor = rgba(col, .8); c.shadowBlur = (3 + 6 * D) * S;
      c.strokeStyle = rgba(col, .35 + .63 * D); c.lineWidth = 1.4 * S; c.beginPath();
      for (i = 0; i <= 72; i++) {
        u = i / 72; i ? c.lineTo((x + u * w) * S, wy(u) * S) : c.moveTo((x + u * w) * S, wy(u) * S);
      }
      c.stroke(); c.restore();
      var ntw = Math.floor(open * 14);
      for (k = 0; k < ntw; k++) {
        var tw = hash(k * 5.1 + Math.floor(td * 3)); if (tw < .35) continue;
        u = hash(k * 11.3 + Math.floor(td * 0.8));
        c.fillStyle = rgba(HOT, (.25 + .6 * tw) * open);
        c.fillRect((x + u * w) * S, (wy(u) - 2 - hash(k * 3.7) * 4) * S, 1.4 * S, 1.4 * S);
      }
    } else {                                // WARP - solo wave splitting into a braid
      var amp = h * (.05 + .33 * v), spread = Math.min(1, v * 2.2), meshA = Math.max(0, (v - .30) * 2.2);
      var warp = function (u, ro, ph) {
        return Math.sin(u * 6.283 * 1.35 + t * 1.9 + ro * .9 + ph) * amp * Math.sin(u * 3.1 + .6 + ro);
      };
      if (meshA > 0) {
        c.strokeStyle = rgba(col, .22 * meshA); c.lineWidth = 1 * S;
        for (i = 0; i <= 12; i++) {
          u = i / 12; c.beginPath();
          c.moveTo((x + u * w) * S, (cy - h * .30 * spread + warp(u, 0, 0)) * S);
          c.lineTo((x + u * w) * S, (cy + h * .30 * spread + warp(u, 2, 0)) * S); c.stroke();
        }
      }
      for (var r = 0; r < 3; r++) {
        var off = (r - 1) * h * .30 * spread, rowA = r === 1 ? 1 : spread;
        if (rowA < .03) continue;
        c.save(); c.shadowColor = rgba(col, .9); c.shadowBlur = (4 + 7 * v) * S;
        c.strokeStyle = rgba(col, .95 * rowA); c.lineWidth = 1.4 * S; c.beginPath();
        for (i = 0; i <= 40; i++) {
          u = i / 40; var wyy = (cy + off + warp(u, r, 0)) * S;
          i ? c.lineTo((x + u * w) * S, wyy) : c.moveTo((x + u * w) * S, wyy);
        }
        c.stroke(); c.restore();
      }
    }
    c.restore();
  }

  var P = {};
  function drawPanel(c, t) {
    var gx, gy, xx, yy, i;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.fillStyle = BG; c.fillRect(0, 0, 620 * S, 620 * S);
    c.fillStyle = rgba(DIM, .26);
    for (gx = 22; gx <= 598; gx += 48) for (yy = 40; yy < 600; yy += 8) c.fillRect(gx * S, yy * S, 1 * S, 2 * S);
    for (gy = 88; gy <= 600; gy += 48) for (xx = 22; xx < 598; xx += 8) c.fillRect(xx * S, gy * S, 2 * S, 1 * S);
    box(c, 10, 10, 600, 600, DIM, .55);
    tx(c, 'TEXTURE.SYS', 22, 32, INK, .95, 12, 'left', true, 5);
    tx(c, 'TASCAM 424 // SERIES 9-K', 598, 32, DIM, .9, 10, 'right');
    box(c, 22, 44, 576, 28, INK2, .5);
    tx(c, 'PRESET', 32, 63, INK, .95, 10, 'left', true);
    tx(c, '<', 92, 63.5, INK, .9, 11); tx(c, '>', 292, 63.5, INK, .9, 11);
    tx(c, 'Jet Lead', 190, 63.5, INK, 1, 12, 'center', true, 4);
    ['RANDOM', 'RESET', 'GESTURE'].forEach(function (s, i) { tx(c, s, 320 + i * 94, 63, INK, .9, 10, 'left', true); });
    [306, 406, 500].forEach(function (x) { c.fillStyle = rgba(DIM, .5); c.fillRect(x * S, 46 * S, 1 * S, 24 * S); });

    var hz = (0.1 * Math.pow(80, P.rate)).toFixed(2);
    tx(c, 'CHAIN  SWELL > CRUNCH > DARKNESS > WARP > PITCH', 22, 96, INK2, .92, 10);
    tx(c, 'FLANGER  RATE ' + hz + 'HZ  COMB ' + Math.round(P.manual * 100) + '%  DEPTH ' +
      Math.round(P.depth * 100) + '%  RES ' + Math.round(P.res * 100) + '%', 22, 109, DIM, .85, 10);
    tx(c, 'BLOOM  AMOUNT ' + Math.round(P.amount * 100) + '%  DRIFT ' + Math.round(P.drift * 100) +
      '%  OUT ' + (-9 - 6 * Math.sin(t * 1.3)).toFixed(1) + ' DB ' + (Math.floor(t * 2.2) % 2 ? '' : '_'),
      22, 122, DIM, .85, 10);

    box(c, 344, 84, 254, 46, DIM, .5);
    tx(c, 'MIX', 352, 100, INK, .95, 10, 'left', true);
    tx(c, Math.round(P.mix * 100) + '%', 590, 100, INK, .95, 10, 'right', true);
    bar(c, 352, 106, 238, 17, P.mix, INK2, t);

    box(c, 22, 142, 310, 270, DIM, .5);
    tx(c, 'TRANSPORT', 30, 158, INK, .9, 10, 'left', true, 4);
    tx(c, '// LIVE', 104, 158, INK2, Math.sin(t * 3) > 0 ? .9 : .5, 10);
    var Lx = 99, Rx = 255, Cy = 290, RR = 50;
    var spin = t * (.25 + P.rate * 2.4), lfo = Math.sin(t * 6.283 * Math.max(.02, +hz));

    c.save(); c.beginPath(); c.rect(24 * S, 146 * S, 306 * S, 262 * S); c.clip();
    for (var th = 0; th < 7; th++) {
      var yB = 162 + th * 36, amp = 2.5 + P.drift * 6 + (th % 3) * 1.2, flow = t * (.25 + P.rate * 1.35);
      c.strokeStyle = rgba(INK2, .075 + .035 * hash(th * 3.3)); c.lineWidth = 1 * S; c.beginPath();
      for (i = 0; i <= 44; i++) {
        var u = i / 44;
        var fy = yB + Math.sin(u * 6.283 * 1.25 + flow + th * 1.7) * amp +
          Math.sin(u * 6.283 * .45 - flow * .6 + th * 1.7) * amp * .45;
        i ? c.lineTo((22 + u * 310) * S, fy * S) : c.moveTo((22 + u * 310) * S, fy * S);
      }
      c.stroke();
    }
    c.restore();

    [[Lx, spin], [Rx, spin * 1.45]].forEach(function (p) {
      var cx = p[0], ang = p[1];
      [[RR, INK, .9, 1.2], [RR * .62, INK2, .55, 1], [RR * .30, INK2, .65, 1]].forEach(function (q) {
        c.save(); c.shadowColor = rgba(q[1], .6); c.shadowBlur = 6 * S;
        c.strokeStyle = rgba(q[1], q[2]); c.lineWidth = q[3] * S;
        c.beginPath(); c.arc(cx * S, Cy * S, q[0] * S, 0, 7); c.stroke(); c.restore();
      });
      for (var k = 0; k < 6; k++) {
        var a = ang + k * 1.047;
        line(c, cx + Math.cos(a) * RR * .30, Cy + Math.sin(a) * RR * .30,
          cx + Math.cos(a) * RR * .62, Cy + Math.sin(a) * RR * .62, INK2, .6, 1);
      }
      c.fillStyle = rgba(HOT, .75 + .2 * Math.sin(t * 1.4 + cx));
      c.fillRect((cx - 1.5) * S, (Cy - 1.5) * S, 3 * S, 3 * S);
    });

    var fl = Math.sin(t * 11) * .7, gd = 2.5 + P.drift * 6 + Math.sin(t * 6.283 * .18) * 1.5;
    [[0, INK, .95, 1.3], [gd, INK2, .5, 1]].forEach(function (q) {
      var o = q[0];
      c.save(); c.shadowColor = rgba(q[1], .5); c.shadowBlur = 5 * S;
      c.strokeStyle = rgba(q[1], q[2]); c.lineWidth = q[3] * S; c.beginPath();
      c.moveTo(Lx * S, (Cy - RR + o) * S); c.lineTo(147 * S, (218 + fl + o) * S);
      c.lineTo(207 * S, (218 + fl + o) * S); c.lineTo(Rx * S, (Cy - RR + o) * S);
      c.stroke(); c.restore();
    });
    var hot = Math.min(2, Math.floor(P.manual * 3));
    [159, 177, 195].forEach(function (hx, i) {
      box(c, hx, 196, 10, 14, INK, .8);
      c.fillStyle = rgba(i === hot ? HOT : INK2, i === hot ? .45 + .5 * (lfo * .5 + .5) : .4);
      c.fillRect((hx + 3) * S, 199 * S, 4 * S, 8 * S);
    });
    tx(c, 'RATE  ' + hz + 'HZ', Lx - 34, 394, INK2, .95, 13, 'left', true, 4);
    tx(c, 'DRIFT  ' + Math.round(P.drift * 100) + '%', Rx - 32, 378, INK2, .95, 13, 'left', true, 4);
    tx(c, 'MANUAL  ' + Math.round(P.manual * 100) + '%', 183, 162, INK2, .95, 13, 'left', true, 4);

    box(c, 344, 142, 254, 270, DIM, .5);
    tx(c, 'CHARACTER', 352, 158, INK, .9, 10, 'left', true, 4);
    line(c, 352, 164, 590, 164, DIM, .4, 1);
    [['SWELL', P.swell, 0, 352, 174], ['CRUNCH', P.crunch, 1, 475, 174],
     ['DARKNESS', P.dark, 2, 352, 270], ['WARP', P.warp, 3, 475, 270]].forEach(function (b) {
      var nm = b[0], v = b[1], kind = b[2], bx = b[3], by = b[4];
      box(c, bx, by, 115, 88, STAGE[kind], .55);
      tx(c, nm, bx + 6, by + 14, STAGE[kind], .95, 10, 'left', true);
      tx(c, Math.round(v * 100) + '%', bx + 109, by + 14, STAGE[kind], .95, 10, 'right', true);
      glyph(c, kind, bx + 10, by + 24, 95, 50, v, t, STAGE[kind]);
      c.fillStyle = rgba(STAGE[kind], .25); c.fillRect((bx + 6) * S, (by + 82) * S, 103 * S, 2 * S);
      c.fillStyle = rgba(STAGE[kind], .95); c.fillRect((bx + 6) * S, (by + 82) * S, 103 * v * S, 2 * S);
    });
    tx(c, 'PITCH', 352, 381, STAGE[4], .95, 10, 'left', true);
    tx(c, '0 ST', 590, 381, STAGE[4], .95, 10, 'right', true);
    bar(c, 352, 386, 238, 17, P.pitch, STAGE[4], t);

    box(c, 22, 424, 576, 180, DIM, .5);
    tx(c, 'MODULATION', 30, 440, INK, .9, 10, 'left', true, 4);
    line(c, 30, 446, 590, 446, DIM, .4, 1);
    [['MANUAL', P.manual, 30, 460, INK2], ['RATE', P.rate, 322, 460, INK2],
     ['DEPTH', P.depth, 30, 506, INK2], ['RES', P.res, 322, 506, INK2],
     ['AMOUNT', P.amount, 30, 552, '#C46EE8'], ['DRIFT', P.drift, 322, 552, '#C46EE8']].forEach(function (m) {
      var nm = m[0], v = m[1], x = m[2], y = m[3], col = m[4];
      tx(c, nm, x, y + 9, INK, .95, 10, 'left', true);
      tx(c, nm === 'RATE' ? hz + 'HZ' : Math.round(v * 100) + '%', x + 270, y + 9, INK, .95, 10, 'right', true);
      bar(c, x, y + 14, 270, 17, v, col, t);
    });
  }

  /* every value breathes on its own slow cycle, so the panel always looks played */
  function setValues(t) {
    P.rate = .28 + .26 * (.5 + .5 * Math.sin(t * .21));
    P.drift = .30 + .45 * (.5 + .5 * Math.sin(t * .17 + 1.4));
    P.manual = .12 + .55 * (.5 + .5 * Math.sin(t * .29 + 2.1));
    P.swell = .10 + .80 * (.5 + .5 * Math.sin(t * .23 + .7));
    P.crunch = .25 + .65 * (.5 + .5 * Math.sin(t * .19 + 3.0));
    P.dark = .10 + .70 * (.5 + .5 * Math.sin(t * .07 + 1.9));
    P.warp = .10 + .75 * (.5 + .5 * Math.sin(t * .26 + 4.2));
    P.depth = .25 + .55 * (.5 + .5 * Math.sin(t * .13 + 2.6));
    P.res = .10 + .45 * (.5 + .5 * Math.sin(t * .11 + 5.1));
    P.amount = .05 + .55 * (.5 + .5 * Math.sin(t * .16 + .3));
    P.mix = .85 + .15 * (.5 + .5 * Math.sin(t * .09));
    P.pitch = .20 + .55 * (.5 + .5 * Math.sin(t * .12 + 3.7));
  }
  function frame(t) { setValues(t); drawPanel(g, t); if (g2) g2.drawImage(cv, 0, 0); }

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (still) { frame(6.2); return; }   // one good-looking still, no loop

  var MIN_MS = 1000 / 30;              // ambient motion; 30fps is plenty
  var running = false, visible = false, t0 = null, last = -1e9, raf = 0;
  function tick(ms) {
    if (!running) return;
    raf = requestAnimationFrame(tick);
    if (ms - last < MIN_MS) return;
    last = ms;
    if (t0 === null) t0 = ms;
    frame((ms - t0) / 1000);
  }
  function sync() {
    var want = visible && !document.hidden;
    if (want === running) return;
    running = want;
    if (running) { last = -1e9; raf = requestAnimationFrame(tick); }
    else cancelAnimationFrame(raf);
  }
  frame(0);                            // paint immediately, do not wait for the observer
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; sync(); },
      { rootMargin: '120px' }).observe(cv);
  } else { visible = true; }
  document.addEventListener('visibilitychange', sync);
  sync();

  /* pointer parallax - transform only, and only on real pointers */
  var stage = document.querySelector('.ev-stage'), tilt = document.querySelector('.ev-tilt');
  if (stage && tilt && window.matchMedia && window.matchMedia('(hover:hover)').matches) {
    var pend = false, px = 0, py = 0;
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      px = (e.clientX - r.left) / r.width - .5;
      py = (e.clientY - r.top) / r.height - .5;
      if (pend) return; pend = true;
      requestAnimationFrame(function () {
        pend = false;
        tilt.style.setProperty('--tx', (px * 9).toFixed(2) + 'deg');
        tilt.style.setProperty('--ty', (-py * 7).toFixed(2) + 'deg');
      });
    });
    stage.addEventListener('pointerleave', function () {
      tilt.style.setProperty('--tx', '0deg'); tilt.style.setProperty('--ty', '0deg');
    });
  }
})();
